module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-none/b-none.component.css
// module id = ./src/app/parts/b-none/b-none.component.css
// module chunks = main